module.exports = __webpack_public_path__ + "img/rumm91.dfc6786a.jpg";